/**
 * Conta bancária na Argentina (Transfers 3.0): CBU (banco) ou CVU (carteira virtual).
 *
 * Os dois têm 22 dígitos em dois blocos, cada um com o seu dígito verificador (algoritmo do
 * BCRA): o bloco 1 (8 dígitos) identifica a entidade e a agência; o bloco 2 (14 dígitos), a conta.
 * A UnblockPay recebe o número em `cvu` ou `cbu`; a BlindPay, em `transfers_account`.
 */

const ARGENTINA_ACCOUNT_LENGTH = 22;
const FIRST_BLOCK_WEIGHTS = [7, 1, 3, 9, 7, 1, 3];
const SECOND_BLOCK_WEIGHTS = [3, 9, 7, 1, 3, 9, 7, 1, 3, 9, 7, 1, 3];

function _checkDigitOk(block, weights) {
  const sum = weights.reduce((total, weight, index) => total + Number(block[index]) * weight, 0);

  return (10 - (sum % 10)) % 10 === Number(block[weights.length]);
}

/**
 * CBU ou CVU com 22 dígitos e os dois dígitos verificadores certos. Aceita espaços e traços.
 * @param {string} account
 * @returns {boolean}
 */
function isValidArgentinaAccount(account) {
  const plain = String(account || '').replace(/[\s-]/g, '');

  if (!new RegExp(`^\\d{${ARGENTINA_ACCOUNT_LENGTH}}$`).test(plain)) return false;

  return _checkDigitOk(plain.slice(0, 8), FIRST_BLOCK_WEIGHTS) && _checkDigitOk(plain.slice(8), SECOND_BLOCK_WEIGHTS);
}

export { ARGENTINA_ACCOUNT_LENGTH, isValidArgentinaAccount };

export default { ARGENTINA_ACCOUNT_LENGTH, isValidArgentinaAccount };
